export const coerceBoolean = (value: unknown): boolean => {
  return value != null && `${value}`.toLowerCase() !== 'false' && value !== 0;
};
